import {HistoryBridge} from '../historyBridge';

const historyWeb: HistoryBridge = {
    pushUrlHistory: async (): Promise<void> => undefined,
    replaceUrlHistory: async (): Promise<void> => undefined,
    refresh: async (): Promise<void> => undefined
};

export default historyWeb;
